import * as React from 'react'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router'
import qs from 'qs'
import { getDistance } from 'geolib'

// components
import CatalogLayout from '../../../../components/ui/CatalogLayout/CatalogLayout'
import StoreModal from '../../../../components/home/StoreModal/StoreModal'
import SearchMallModal from '../../../../components/home/SearchMallModal/SearchMallModal'
import SelectMallPromptModal from '../../../../components/home/SelectMallPromptModal/SelectMallPromptModal'
import {
  BannerContent,
  BannerDescription,
  FormContainer,
  Heading,
  RewardsCatalogDescription,
  RewardsCatalogTitle,
  SearchBar,
  StyledBanner,
  StyledCaret,
  StyledCatalogCard,
  StyledCatalogList,
  StyledZingLogo,
} from './MainView.style'

// data
import filterString from '../../../../services/data/filterString'
import { REWARDS_MERCHANTS_CATALOG } from '../../../../services/data/errorNames.json'

// analytics
import {
  setGAPageView,
  setGAEvent,
} from '../../../../services/analytics/google-analytics'

// controllers
import { doGetAllMalls } from '../../../../controllers/Malls'
import {
  doGetRewardsStore,
  doGetZingPartners,
} from '../../../../controllers/Explore'
import sanitizeHTML from '../../../../services/sanitizeHTML'

const Banner = () => (
  <StyledBanner>
    <BannerContent>
      <BannerDescription>
        <StyledZingLogo />
        <RewardsCatalogTitle>Participating Merchants</RewardsCatalogTitle>
        <RewardsCatalogDescription>
          Every Php 200 spend in participating merchants using your linked card
          earns you 1 point.
        </RewardsCatalogDescription>
      </BannerDescription>
    </BannerContent>
  </StyledBanner>
)

class MainView extends React.Component {
  constructor(props) {
    super(props)

    const { history, selectedMallSlug } = props
    const { location } = history

    const { q = '' } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    this.state = {
      zingPartners: [],
      searchQuery: q,
      searched: [],
      searchMallState: false,
      selectModalState: selectedMallSlug === '',
    }
  }

  componentDidMount() {
    const { history, setMalls, malls, selectedMallSlug } = this.props
    const { location } = history
    setGAPageView(location.pathname)

    this.retrieveInitialData()

    const initialSearch = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    this.getParticipatingMerchants(initialSearch.catalogId || 0)

    if (malls.length < 1) {
      doGetAllMalls({ setMalls })
    }

    const { position } = this.state

    const nearestMalls =
      !!position &&
      !!malls &&
      malls
        .map(mall => {
          const mallDistance = getDistance(position, {
            latitude: mall.latitude,
            longitude: mall.longitude,
          })

          return {
            ...mall,
            distance: mallDistance,
          }
        })
        .filter(mall => mall.distance <= 5000 && mall.explore && mall.slugName)
        .sort((a, b) => a.distance - b.distance)

    const forceFavoriteMall = malls
      .filter(mall => mall.favorite && mall.explore && mall.slugName)
      .sort((a, b) => a.name.localeCompare(b.name))

    if (selectedMallSlug === '' && forceFavoriteMall.length) {
      this.selectNearestMall(forceFavoriteMall[0].slugName)
    } else if (selectedMallSlug === '' && nearestMalls.length) {
      const nearestMallSlugName = nearestMalls[0].slugName
      this.selectNearestMall(nearestMallSlugName)
    }
  }

  componentDidUpdate(prevProps) {
    const { match, location, selectedMallSlug } = this.props
    const { viewType, viewId } = match.params
    const {
      viewType: prevViewType,
      viewId: prevViewId,
    } = prevProps.match.params

    if (viewType !== prevViewType || viewId !== prevViewId) {
      this.displayModal()
    }

    if (location.pathname !== prevProps.location.pathname) {
      setGAPageView(location.pathname)
    }

    if (selectedMallSlug !== prevProps.selectedMallSlug) {
      this.getParticipatingMerchants()
    }
  }

  getParticipatingMerchants = () => {
    const {
      accessToken,
      history,
      errorList,
      setError,
      removeError,
      selectedMallSlug,
    } = this.props

    if (errorList.length) {
      removeError(REWARDS_MERCHANTS_CATALOG)
    }

    const search = qs.parse(history.location.search, {
      ignoreQueryPrefix: true,
    })

    const pageLoadStart = Date.now()

    this.setState({ zingPartners: [] }, () => {
      doGetZingPartners({
        accessToken,
        selectedMall:
          selectedMallSlug !== null ? { mallSlugName: selectedMallSlug } : {},
        onSuccess: ({ data }) => {
          this.setState({
            zingPartners: data.sort((a, b) =>
              a.title > b.title ? 1 : a.title < b.title ? -1 : 0,
            ),
            searched: search.q
              ? data.filter(z =>
                  z.title.toLowerCase().includes(search.q.toLowerCase()),
                )
              : [],
          })
          setGAEvent(
            'page',
            'loading_duration',
            'merchants_catalog',
            Date.now() - pageLoadStart,
          )
        },
        onError: error => {
          setError({
            name: REWARDS_MERCHANTS_CATALOG,
            error: error.message,
          })
        },
      })
    })
  }

  retrieveInitialData = async () => {
    const { waitRenderServer, renderServer } = this.props

    waitRenderServer(true)

    await this.displayModal()

    renderServer()
  }

  displayModal = async () => {
    const { match, setMerchantModalData, setMerchantModalStatus } = this.props
    const { zingPartners } = this.state
    const { viewId } = match.params

    if (viewId) {
      let partner = zingPartners.find(p => p.id === viewId)
      setMerchantModalStatus(1)
      try {
        await doGetRewardsStore({ partner, setMerchantModalData })(viewId)
        setMerchantModalStatus(0)
      } catch (e) {
        setMerchantModalStatus(4)
      }
    } else {
      setMerchantModalData({})
      setMerchantModalStatus(null)

      setGAEvent('page', 'page_visit', 'merchants_catalog')
    }
  }

  handleClose = () => {
    const {
      push,
      baseUrl,
      setMerchantModalData,
      setMerchantModalStatus,
      selectedMallSlug,
      match,
    } = this.props
    const { mallSlug } = match.params || selectedMallSlug

    if (push) {
      push(`${baseUrl}/${mallSlug}/`)
      setMerchantModalData({})
      setMerchantModalStatus(null)
    }
  }

  onOpenMallModal = () => {
    this.setState({
      selectModalState: false,
      searchMallState: true,
    })
  }

  onCloseMallModal = () => {
    const { selectedMallSlug } = this.props
    if (selectedMallSlug !== '') {
      this.setState({
        searchMallState: false,
      })
    }
  }

  onChangeMall = mallSlug => {
    const { setSelectedMallSlug } = this.props
    setSelectedMallSlug(mallSlug)
    this.setState({
      searchMallState: false,
    })
  }

  selectNearestMall = mallSlugName => {
    const { replace, baseUrl, match, setSelectedMallSlug } = this.props
    const { viewType, viewId } = match.params

    this.setState({
      searchModalState: false,
      selectModalState: false,
    })

    setSelectedMallSlug(mallSlugName)

    replace(
      `${baseUrl}/${mallSlugName}${
        viewType ? `/${viewType}${viewId ? `/${viewId}` : ''}` : ''
      }`,
    )
  }

  render() {
    const {
      showMerchantModal,
      merchantModalData,
      merchantModalStatus,
      advanceAccount,
      accessToken,
      errorList,
      push,
      baseUrl,
      match,
      setFavoriteMalls,
      favoriteMalls,
      malls,
      selectedMallSlug,
      setSelectedMallSlug,
      ...theProps
    } = this.props

    const {
      zingPartners,
      searched,
      searchMallState,
      selectModalState,
      searchQuery: searchQueryState,
    } = this.state

    const currentMall = malls.find(
      mall =>
        mall.slugName === selectedMallSlug && mall.explore && mall.slugName,
    )
    const { mallSlug } = match.params
    const { slugName: mallSlugName } = currentMall || mallSlug || {}

    return (
      <CatalogLayout banner={Banner} accessToken={accessToken} {...theProps}>
        <Heading>
          <FormContainer>
            <SearchBar
              onClick={this.onOpenMallModal}
              style={{
                color: currentMall ? null : 'var(--color-fg-light)',
              }}
            >
              {currentMall ? currentMall.name : 'Select an Ayala Mall'}
              <StyledCaret />
            </SearchBar>
          </FormContainer>
        </Heading>
        <StyledCatalogList
          dataSource={searchQueryState ? searched : zingPartners}
          loadingComponent={() => (
            <StyledCatalogCard
              loading
              error={errorList.find(
                error => error.name === REWARDS_MERCHANTS_CATALOG,
              )}
              errorMessage="Failed to load Merchants."
              onRetry={this.getParticipatingMerchants}
            />
          )}
          renderItem={(zingPartner, index) => (
            <StyledCatalogCard
              id={index}
              key={zingPartner.id}
              data={{
                id: zingPartner.id,
                name: zingPartner.merchant.name,
                imageUrl: zingPartner.merchant.bannerUrl,
              }}
              logoUrl={zingPartner.merchant.logoUrl}
              push={push}
              to={sanitizeHTML(`${baseUrl}/${mallSlugName}/${zingPartner.id}`)}
              onClick={() =>
                setGAEvent(
                  'item_clicks',
                  'view_merchants_catalog_item',
                  zingPartner.title,
                )
              }
            />
          )}
        />
        <StoreModal
          malls={malls}
          show={showMerchantModal}
          data={merchantModalData}
          loading={merchantModalStatus}
          onClose={this.handleClose}
        />
        <SelectMallPromptModal
          show={!showMerchantModal && selectModalState && !currentMall}
          onConfirmClick={this.onOpenMallModal}
        />
        <SearchMallModal
          modalState={searchMallState}
          onClose={this.onCloseMallModal}
          malls={malls}
          push={push}
          match={match}
          accessToken={accessToken}
          setFavoriteMalls={setFavoriteMalls}
          baseUrl={baseUrl}
          currentMall={selectedMallSlug}
          onChangeMall={this.onChangeMall}
          selectedMall={currentMall}
          favoriteMalls={favoriteMalls}
          displayClose={selectedMallSlug !== ''}
          setSelectedMallSlug={setSelectedMallSlug}
        />
        {showMerchantModal && merchantModalData && merchantModalData.merchant && (
          <Helmet defaultTitle={merchantModalData.merchant.name}>
            <meta
              property="og:title"
              content={merchantModalData.merchant.name}
            />
            <meta
              property="og:description"
              content={
                merchantModalData.merchant.description &&
                filterString(merchantModalData.merchant.description)
              }
            />
            <meta
              property="og:image"
              content={merchantModalData.merchant.bannerUrl}
            />
            <meta property="og:type" content="website" />
          </Helmet>
        )}
      </CatalogLayout>
    )
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default withRouter(MainView)
